import React, { forwardRef } from 'react';
import cn from 'classnames';

var styles = {"textarea":"textarea__textarea_1wc9q","overflowHidden":"textarea__overflowHidden_1wc9q","customScrollbar":"textarea__customScrollbar_1wc9q","hasInnerLabel":"textarea__hasInnerLabel_1wc9q","pseudoTextarea":"textarea__pseudoTextarea_1wc9q","overflow":"textarea__overflow_1wc9q","nativeScrollbar":"textarea__nativeScrollbar_1wc9q","sub":"textarea__sub_1wc9q","focusVisible":"textarea__focusVisible_1wc9q","filled":"textarea__filled_1wc9q","s":"textarea__s_1wc9q","m":"textarea__m_1wc9q","l":"textarea__l_1wc9q","xl":"textarea__xl_1wc9q","wrapper":"textarea__wrapper_1wc9q","resizeVertical":"textarea__resizeVertical_1wc9q"};
require('./index.css');

var PseudoTextArea = forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 's' : _b, pseudoTextareaClassName = _a.pseudoTextareaClassName, maxLength = _a.maxLength, value = _a.value;
    return (React.createElement("div", { className: cn(styles.pseudoTextarea, styles[size], pseudoTextareaClassName), ref: ref, hidden: true },
        React.createElement("span", null, value.slice(0, maxLength)),
        React.createElement("span", { className: cn(styles.overflow) }, value.slice(maxLength)),
        React.createElement("br", null)));
});

export { PseudoTextArea as P, styles as s };
